import styled from "styled-components";

export const FooterContainer = styled.div`
  padding-top: 30px;
  padding-bottom: 15px;
  background: linear-gradient(#150b1f, #000);
`;

export const FooterWrapper = styled.div`
  max-width: 500px;
  margin: 0 auto;
`;

export const FooterLinksContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 10px;
`;

export const FooterLink = styled.a`
  font-size: 0.9rem;
  text-decoration: none;
  color: white;
  margin: 0 10px;
  display: flex;
  align-items: center;
  transition: all 0.3s;

  &:hover {
    color: #b05ffd;
  }
`;

export const FooterH1 = styled.h1`
  font-size: 1rem;
  color: white;
  text-align: center;
  margin-bottom: 10px;
`;
